import { useEffect, useState } from 'react';
import api from '../lib/api';

export default function Quests() {
  const [quests, setQuests] = useState([]);
  useEffect(() => { api.get('/quests').then(r => setQuests(r.data)).catch(() => {}); }, []);
  const daily = quests.filter(q => q.type === 'daily');
  const weekly = quests.filter(q => q.type === 'weekly');
  return (
    <div className="space-y-6" data-testid="quests-root">
      <h2 className="font-serif text-3xl">Quests</h2>
      <Section title="Daily" items={daily} testid="quests-daily" />
      <Section title="Weekly" items={weekly} testid="quests-weekly" />
    </div>
  );
}
function Section({ title, items, testid }) {
  return (
    <section data-testid={testid}>
      <h3 className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground mb-3">{title}</h3>
      <div className="space-y-3">
        {items.map(q => {
          const pct = Math.round((q.progress / q.target) * 100);
          return (
            <div key={q.quest_id} className={`rounded-3xl bg-card border ${q.complete ? 'border-accent/40' : 'border-white/5'} p-5`}>
              <div className="flex items-start justify-between">
                <div>
                  <p className="font-serif text-lg">{q.title}</p>
                  <p className="text-xs text-muted-foreground mt-1">{q.description}</p>
                </div>
                <span className="font-mono text-xs text-accent whitespace-nowrap">+{q.xp_reward} XP</span>
              </div>
              <div className="mt-3 h-1.5 bg-white/10 rounded-full overflow-hidden"><div className="h-full bg-accent transition-all" style={{ width: `${Math.min(100, pct)}%` }} /></div>
              <p className="text-[10px] font-mono text-muted-foreground mt-1">{q.progress}/{q.target}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
